import $ from "jquery";
import ko from "knockout";
import {currentBrowser, createEventListener} from "./tools";
import "../../../web/lib/fullScreen/fullScreen";

const PlayerToolBar = function($app) {
	const $player = $app.require('player');
	const $toolBar = this;
	const $progressBar = this.progressBar = new ProgressBar();
	let hideTimer;

	const $playerContainer = $('#playerContainer');

	createEventListener(this);

	this.$player = $player;

    this.pipEnabled = ko.computed(() => document.pictureInPictureEnabled);
	this.isShowHint = ko.observable(false);
	this.hintPosition = ko.observable(null);
	this.hintPlayerTime = ko.computed(() => Math.floor(this.hintPosition() * $progressBar.duration()));
	this.hintEpisode = ko.computed(() => {
		if($app.currentStream()) {
			if($app.currentEpisode() && $app.currentEpisode().isRecorded()) return null;
			if($app.currentStream().isEpisodeRecorded()) return null;
			return $app.currentStream().getEpisodeByPlayerTime(this.hintPlayerTime(), $app.currentStreamDay());
		}
	});
	this.hintAbsoluteTime = ko.computed(() => $app.currentStream() && $app.currentStream().getAbsoluteTimeByPlayerTime(this.hintPlayerTime(), $app.currentStreamDay()));

	this.nextEpisode = ko.computed(() => {
		if(!$app.currentEpisode()) return null;
		let nextEpisode = $app.currentEpisode().getNextEpisode();
		if(!nextEpisode) {
			if(!$app.currentStream()) return null;
			const nextStream = $app.currentStream().getNextStream();
			if(!nextStream || nextStream.episode().length === 0) return null;
			nextEpisode = nextStream.episode()[0];
		}
		if(!nextEpisode.stream().isEpisodeRecorded()) return null;
		return nextEpisode;
	});
	this.clickNextEpisode = () => $app.setEpisode(this.nextEpisode());

	this.isShowContextMenu = ko.observable(false);

	this.setQuality = quality => this.trigger('quality', [quality]);
	this.setLanguage = language => this.trigger('language', [language]);

	function ProgressBar() {
		this.isDrag = ko.observable(false);
		this.dragPosition = ko.observable(0);
		this.duration = ko.computed(() => {
			if($app.episode() && !$app.episode().isRecorded()) return $app.episode().duration() || ($app.episode().timeStop() - $app.episode().timeStart());
			return $player.duration();
		});
		this.currentTime = ko.computed(() => {
			if(!$player.duration()) return 0;
			if($app.episode() && !$app.episode().isRecorded()) return $player.currentTime() - $app.episode().playerTimeStart();
			if($player.live()) return this.duration();
			return $player.currentTime();
		});
		this.progress = ko.computed(() => this.currentTime() / this.duration());
		this.position = ko.computed(() => this.isDrag() ? this.dragPosition() : this.progress());
		this.setPosition = (position, delay) => {
			delay = delay ? delay : 0;
			if(this.setPosition.timer) {
				clearTimeout(this.setPosition.timer);
			}

			this.setPosition.timer = setTimeout(() => {
				$player.setCurrentTime($app.episode() && !$app.episode().isRecorded() ? position + $app.episode().playerTimeStart() : position)
					.finally(() => this.isDrag(false));
			}, delay);
		};

		this.onDragStart = (context, dragStartEvent) => {
			const options = {
				min: 0,
				max: 1
			};

			let position;

			const onDragMove = (dragEvent) => {
				const target = $(dragStartEvent.target);
				const pageX = ((dragEvent.type === 'touchstart' || dragEvent.type === 'touchmove') ? dragEvent.originalEvent.changedTouches[0] : dragEvent).pageX;
				position = (pageX - target.offset().left) / target.width();

				if(position < options.min) position = options.min;
				else if(position > options.max) position = options.max;

				this.dragPosition(position);
			};

			const onDragEnd = () => {
				$(document).off('mousemove touchmove', onDragMove);
				$(document).off('mouseup touchend', onDragEnd);

				this.setPosition(position * this.duration());
			};

			$(document).on('mousemove touchmove', onDragMove);
			$(document).on('mouseup touchend', onDragEnd);
			onDragMove(dragStartEvent);
			this.isDrag(true);
		};

		this.showHint = (context, event) => {
			if(this.hintHideTimeout) clearTimeout(this.hintHideTimeout);
			$toolBar.isShowHint(true);
			this.hintHideTimeout = setTimeout(() => this.hideHint(), 1000);
			$toolBar.hintPosition(event.offsetX / $(event.currentTarget).width());
		};
		this.hideHint = () => {
			if(this.hintHideTimeout) clearTimeout(this.hintHideTimeout);
			$toolBar.isShowHint(false);
		};
	}

    this.clickPipButton = () => this.trigger('pip');
	this.clickPlayerSizeButton = () => this.trigger('resize');
	this.clickFullScreenButton = () => this.trigger('fullScreen');
	this.clickLiveButton = () => this.trigger('live');
	this.setMuted = () => this.trigger('muted', [!this.$player.muted()]);
	this.setVolume = volume => this.trigger('volume', [volume]);
	this.clickPlay = () => $player.paused() ? this.trigger('play') : this.trigger('pause');

	this.startFromLive = ko.observable(true);
	this.onClickBigPlay = () => {
		this.clickPlay();
		if(this.startFromLive() && $app.currentStream().isLive()) {
			this.startFromLive(false);
			this.clickLiveButton();
		}
	};
	$app.currentStream.subscribe(() => this.startFromLive(true));

	this.clickLikeButton = () => this.trigger('like');
	this.clickShareButton = () => this.trigger('share');
	this.clickCompactButton = () => this.trigger('compact');

	this.autoPlayTimeout = ko.observable(0);

	this.isShowPlayButton = ko.computed(() => $player.paused() && !$player.isShowBuffering());
	this.isVolumeEnabled = ko.observable(false);

	this.isFullScreenSupported = ko.computed(() => $(document.body).isFullScreenSupported() || currentBrowser.isMobile());

	this.visible = ko.observable(true);

	this.isShow = ko.computed(() => this.visible() || $progressBar.isDrag() || $player.paused());

	let titleScrollTimer;
	this.onHeaderMouseEnter = () => {
		const titleContainerWidth = $('.eventTitle').innerWidth();
		const title = $('.eventTitle div');
		const titleWidth = title.outerWidth();
		let position = 0;

		titleScrollTimer = setInterval(() => {
			if(++position > titleWidth) {
				position = -titleContainerWidth;
			}
			title.css({left: -position});
		}, 1000/50);
	};
	this.onHeaderMouseLeave = () => {
		$('.eventTitle div').animate({left: 0});
		clearInterval(titleScrollTimer);
	};

	$playerContainer
		.on('mousemove', event => {
			const $player = $playerContainer.find('player').get(0);
			if($player === event.target || $.contains($player, event.target)) {
				clearTimeout(hideTimer);
				this.visible(true);
				hideTimer = setTimeout(() => this.visible(false), 3000);
			}
		})
		.on('mouseleave', () => {
			clearTimeout(hideTimer);
			this.visible(false);
		})
	;

	this.buttonEnable = (name, enable) => {
		if(this.button[name]) {
			this.button[name](enable);
		}
		return this;
	};

};

export default PlayerToolBar;
